export enum UserRole {
  API = 'api',
  ADMIN = 'llab_admin',
  GENERAL_MANAGER = 'llab_general_manager',
  CONTENT_MANAGER = 'llab_content_manager',
  USER_MANAGER = 'llab_user_manager',
  VIEWER = 'llab_viewer',
  LEARNER = 'llab_learner',
  PROOFREADER = 'llab_proofreaders'
}
